const NAME = "PROCESS_SCHEDULING";

export default NAME;
